import type { LiveTradeCreateRequest, LiveTradeResponse } from 'apiConnector/secondary-market/live/models';
import { secondaryMarketTradeActionsFactory } from 'state/secondaryMarket/shared/trade/trade.action';

export const liveTradeActions = secondaryMarketTradeActionsFactory<LiveTradeCreateRequest, LiveTradeResponse>('LIVE');
type TypeofLiveTradeActions = typeof liveTradeActions;
export type SecondaryMarketLiveTradeRequested = ReturnType<TypeofLiveTradeActions['secondaryMarketTradeRequested']>;
export type SecondaryMarketLiveTradeReceived = ReturnType<TypeofLiveTradeActions['secondaryMarketTradeReceived']>;
export type SecondaryMarketLiveTradeFailed = ReturnType<TypeofLiveTradeActions['secondaryMarketTradeFailed']>;
export type SecondaryMarketLiveTradeRejected = ReturnType<TypeofLiveTradeActions['secondaryMarketTradeRejected']>;

export type SecondaryMarketLiveTradeActions = ReturnType<TypeofLiveTradeActions[keyof TypeofLiveTradeActions]>;
